export default {
    getInvoices:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },postInvoice:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },postControlNumberState:{
        isLoggedIn:false,
        data:{},
        error:null,
        loading:false,
    },
}